import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { from, SubscriptionLike } from 'rxjs';
import { RefundModel } from 'src/app/models/refund.model';
import { ReturnDbService } from 'src/app/services/data/return-db.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';
import { LocalStorageService } from 'src/app/services/storage/local-storage.service';
import { SyncService } from 'src/app/services/sync/sync.service';

@Component({
  selector: 'app-refund-list',
  templateUrl: './refund-list.component.html',
  styleUrls: ['./refund-list.component.scss'],
})
export class RefundListComponent implements OnInit, OnDestroy {
  public date1: Date;
  public date2: Date;
  public refunds: RefundModel[] = [];
  public loading = false;
  public hasError = false;
  public errorMessage = '';
  preiodDate = true;
  private returnService?: ReturnDbService;
  private subscriptions: SubscriptionLike[] = [];

  constructor(
    public dialog: MatDialog,

    public connMgr: ConnectionManagerService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private sync: SyncService,
    public localStrg: LocalStorageService
  ) {
    const tempDate = new Date();
    this.date1 = new Date(
      tempDate.getUTCFullYear(),
      tempDate.getUTCMonth(),
      tempDate.getUTCDate()
    );
    this.date2 = new Date(
      tempDate.getUTCFullYear(),
      tempDate.getUTCMonth(),
      tempDate.getUTCDate()
    );
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const dt1 = params.get('dt1');

      if (dt1 !== null && dt1 !== undefined && dt1 !== '') {
        const dat = new Date(Date.parse(dt1));
        this.date1 = dat;

        const dt2 = params.get('dt2');
        if (!dt2) {
          this.date2 = new Date(2099, 1, 1);
        } else {
          const dat2 = new Date(Date.parse(dt2));
          this.date2 = dat2;
        }

        this.preiodDate = params.get('period') === 'true' ? true : false;
      }

      if (this.date1 > this.date2) {
        this.date1 = this.date2;
      }

      const r = this.connMgr.activeServerObservable().subscribe(() => {
        from(this.connMgr.getDb()).subscribe((db) => {
          if (!db) return;
          this.returnService = new ReturnDbService(db);
          this.updateData();
        });
      });
      this.subscriptions.push(r);

      const s = this.sync.syncEnd.subscribe((x) => this.updateData());
      this.subscriptions.push(s);
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

  updateData() {
    this.resetCounters();
    this.hasError = false;

    if (!this.returnService) {
      this.refunds = [];
      return;
    }

    this.loading = true;

    let dt2: Date = new Date(this.date2);
    dt2 = new Date(dt2.setDate(dt2.getDate() + 1));

    if (!this.localStrg.searchOptions.orderByDeliveryDate) {
      this.returnService
        .getReturntsByDate(this.date1, dt2)
        .then((data) => {
          this.mapData(data ?? []);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error.message ?? JSON.stringify(error);
        });
    } else {
      const dt1 = new Date(
        this.date1.getFullYear(),
        this.date1.getMonth(),
        this.date1.getDate()
      );
      const dt2 = new Date(
        this.date2.getFullYear(),
        this.date2.getMonth(),
        this.date2.getDate(),
        23,
        59,
        59
      );
      this.returnService
        .getReturntsByDate(dt1, dt2)
        .then((data) => {
          if (data) {
            this.mapData(data);
          }
        })
        .catch((error) => {
          this.hasError = true;
          this.errorMessage = JSON.stringify(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  private mapData(data: RefundModel[]): void {
    this.refunds = data;
    this.resetCounters();
  }

  total = 0;
  totalSumm = 0;
  commited = 0;
  commitedSumm = 0;

  private resetCounters() {
    this.total = 0;
    this.totalSumm = 0;
    this.commited = 0;
    this.commitedSumm = 0;

    if (!this.refunds) return;

    this.refunds.forEach((element) => {
      this.total++;

      if (element.statusId === 6) {
        this.commitedSumm += element.summa;
        this.commited++;
      }

      this.totalSumm += element.summa ?? 0;
    });
  }
  dateModeChange() {
    this.localStrg.save();
  }

  swipe(plus: boolean) {
    if (plus) {
      this.date1 = new Date(
        this.date1.getFullYear(),
        this.date1.getMonth(),
        this.date1.getDate() + 1
      );
    } else {
      this.date1 = new Date(
        this.date1.getFullYear(),
        this.date1.getMonth(),
        this.date1.getDate() - 1
      );
    }

    this.date2 = this.date1;
    this.changed();
  }

  changed(): void {
    const dt1 = this.datePipe.transform(this.date1, 'yyyy-MM-dd');
    const dt2 = this.datePipe.transform(this.date2, 'yyyy-MM-dd');
    void this.router.navigate(['/refunds', dt1, dt2]);
  }

    public completeConfirm(refund: RefundModel) {
      const idx = this.refunds.findIndex(a => a.id === refund.id)
      if (idx < 0) {
        console.error('cant find order')
        return
      }
  
      this.refunds[idx] = refund
      this.resetCounters()
    }

}
